import styled from 'styled-components';

import {
  MOBILE_PADDING,
  SCREEN_LOCKUP_WIDTH,
  PAGE_WIDTH,
  WHITE,
  NAVIGATION_DESKTOP_HEIGHT,
  NAVIGATION_MOBILE_HEIGHT,
} from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Section = styled.section`
  position: relative;
  padding: ${60 + NAVIGATION_MOBILE_HEIGHT}px ${MOBILE_PADDING}px 3em;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: -${NAVIGATION_MOBILE_HEIGHT}px auto 0;
  background-color: #000;

  ${media.tabletL`
    padding: ${86 + NAVIGATION_DESKTOP_HEIGHT}px 0 6em;
    margin: -${NAVIGATION_DESKTOP_HEIGHT}px auto 0;
  `};
`;

export const SectionInner = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
`;

export const ContentWrapper = styled.div`
  text-align: center;
  color: ${WHITE};
  max-width: 940px;

  ${media.tabletL`
    margin: 0 auto;
    text-align: center;
  `};
`;

export const Subtitle = styled.h1`
  font-size: 15px;
  text-transform: uppercase;
  color: ${WHITE};
  > span {
    font-weight: 400;
  }

  ${media.tabletL`
    font-size: 18px;
  `};
`;

export const Title = styled.h1`
  font-size: 30px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${WHITE};
  > span {
    font-weight: 600;
  }

  ${media.tabletL`
    font-size: 54px;
  `};
`;

export const Text = styled.p`
  max-width: 700px;
  margin: 0 auto 2em;

  > span {
    font-weight: 400;
  }

  ${media.tabletL`
    margin: 0 auto 1em;
  `};
`;

export const HeroText = styled.div`
  color: ${WHITE};
  margin: 0 0 0 0;

  ${media.tabletL`
    width: 100%;
  `};

  h1,
  h2,
  h3,
  p {
    color: ${WHITE};
  }

  h1 {
    font-size: 54px;
    margin: 20px 0;
    ${media.tabletL`
      margin: 30px 0;
    `};
  }

  h2 {
    font-size: 22px;
  }

  h3 {
    font-size: 20px;
  }

  p {
    font-size: 16px;
    line-height: 2;
    letter-spacing: 0.1px;
    white-space: pre-line;
    max-width: 700px;
    margin: 0 auto;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/SeminarScheduleHero/SeminarScheduleHero.style.js